export const parseStartTimeToMinutes = (
    value: string | undefined
): number | null => {
    if (!value) return null;
    const trimmed = value.trim();
    if (!trimmed) return null;

    if (trimmed.includes(':')) {
        const [hh, mm] = trimmed.split(':');
        const hours = Number(hh);
        const minutes = Number(mm);
        if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
        return hours * 60 + minutes;
    }

    const numeric = Number(trimmed);
    if (!Number.isFinite(numeric)) return null;
    if (numeric >= 0 && numeric <= 24) return numeric * 60;
    return numeric;
};
